// Does nothing. Used to shim out node.js modules
// which are no-ops in the browser.
export const NOOP = 0
